(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('ControlPauseController', controlPause);
  controlPause.$inject = ['$http', '$state', 'AuthenticationService', '$rootScope', 'CompanyService', 'ngTableParams', 'ReasonService', '$timeout', 'FoundationApi', 'NotificationService'];
  function controlPause ($http, $state, AuthenticationService, $rootScope, CompanyService, ngTableParams, ReasonService, $timeout, FoundationApi, NotificationService) {
    var vmControlPauseCtrl = this;

    $rootScope.getPageLabels('menu.config.pauseSett');

    // Functons
    vmControlPauseCtrl.saveMetadata = saveMetadata;
    vmControlPauseCtrl.validateForm = validateForm;
    vmControlPauseCtrl.saveReason = saveReason;
    vmControlPauseCtrl.editReason = editReason;
    vmControlPauseCtrl.cancelReason = cancelReason;
    vmControlPauseCtrl.deleteReason = deleteReason;
    vmControlPauseCtrl.canDeleteReason = canDeleteReason;
    vmControlPauseCtrl.isValidTitle = isValidTitle;
    vmControlPauseCtrl.changeControlPause = changeControlPause;
    loadMetadata();

    // Objects
    vmControlPauseCtrl.reasons = [];
    vmControlPauseCtrl.types = [];
    vmControlPauseCtrl.disableButton = true;
    vmControlPauseCtrl.hidenGrid = true;
    // Functions Definitions and implementations
    function loadMetadata () {
      CompanyService
        .loadMetadata()
        .$promise
        .then(function (data) {
          vmControlPauseCtrl.metadata = data;
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
        });
    }

    vmControlPauseCtrl.reasons = new ngTableParams({
      page: 1,
      count: 8
    }, {
      counts: [4, 8, 16],
      getData: function ($defer, params) {
        var obj = params.url();
        var keys = Object.keys(vmControlPauseCtrl.reasons.filter);
        for (var i = 0; i < keys.length; i++) {
          var filterValue = vmControlPauseCtrl.filters[keys[i]];
          if (filterValue != null && filterValue !== '') {
            obj['filter[' + keys[i] + ']'] = filterValue;
          }
        }
        ReasonService
          .paged(obj)
          .$promise
          .then(function (data) {
            params.total(data.total);
            $defer.resolve(data.result);
            vmControlPauseCtrl.totalData = data.total;
          }).catch(function (data) {
            NotificationService.errorHandler(data, $rootScope.labels.errorListKnow);
          });
      }
    });

    ReasonService
      .getTypes()
      .$promise
      .then(function (data) {
        vmControlPauseCtrl.types = data;
      }).catch(function (data) {
        NotificationService.errorHandler(data, $rootScope.labels.errorListType);
      });

    function saveMetadata () {
      CompanyService
        .saveMetadata(vmControlPauseCtrl.metadata)
        .$promise
        .then(function (data) {
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.errorConfig);
        });
    }

    function validateForm () {
      if (vmControlPauseCtrl.metadata.hasOwnProperty('control_pause') &&
              vmControlPauseCtrl.metadata.control_pause) {
        if (vmControlPauseCtrl.metadata.control_pause.use_reason && vmControlPauseCtrl.reasons.data.length <= 0) {
          NotificationService.warningHandler(null, $rootScope.labels.reqPauseReason);
          return;
        }// Validação dor form para controle dos motivos
      }
      saveMetadata();
    }

    function isValidTitle () {
      if ((vmControlPauseCtrl.reason.title != undefined || vmControlPauseCtrl.reason.title != null) && vmControlPauseCtrl.reason.title != '') {
        vmControlPauseCtrl.disableButton = false;
      } else {
        vmControlPauseCtrl.disableButton = true;
      }
    }

    function changeControlPause (activeTo) {
      if (activeTo.toUpperCase() == 'disableAll'.toUpperCase()) {
        if (vmControlPauseCtrl.metadata.control_pause.use_reason) {
          vmControlPauseCtrl.metadata.control_pause.is_active = true;
          messageHandler(true, $rootScope.labels.offReasonPause);
          $timeout(function () {
            messageHandler(false);
          }, 5000);
          return;
        }
        if (vmControlPauseCtrl.metadata.control_pause.use_password) {
          vmControlPauseCtrl.metadata.control_pause.is_active = true;
          messageHandler(true, $rootScope.labels.offPasswPause);
          $timeout(function () {
            messageHandler(false);
          }, 5000);
          return;
        }
      }
      if (vmControlPauseCtrl.metadata.control_pause.use_reason || vmControlPauseCtrl.metadata.control_pause.use_password) {
        vmControlPauseCtrl.metadata.control_pause.is_active = true;
      }
    }

    function saveReason () {
      if (vmControlPauseCtrl.metadata.control_pause.use_reason && (!vmControlPauseCtrl.reason || !vmControlPauseCtrl.reason.title)) {
        NotificationService.warningHandler(null, $rootScope.labels.requiredTitle);
        return;
      }
      if (vmControlPauseCtrl.metadata.control_pause.use_reason && (!vmControlPauseCtrl.reason || !vmControlPauseCtrl.reason.type)) {
        NotificationService.warningHandler(null, $rootScope.labels.requiredType);
        return;
      }// Validação dor form para controle dos motivos
      if (!vmControlPauseCtrl.reason.id) {
        ReasonService
          .create({ 'title': vmControlPauseCtrl.reason.title, 'description': vmControlPauseCtrl.reason.description, 'type': vmControlPauseCtrl.reason.type })
          .$promise
          .then(function (data) {
            vmControlPauseCtrl.reason = null;
            NotificationService.successHandler(data, $rootScope.labels.sucCreateReason);
            vmControlPauseCtrl.reasons.reload();
          })
          .catch(function (data) {
            NotificationService.errorHandler(data, $rootScope.labels.errorCreateReason);
          });
      } else {
        ReasonService
          .update({ 'id': vmControlPauseCtrl.reason.id }, { 'title': vmControlPauseCtrl.reason.title, 'description': vmControlPauseCtrl.reason.description, 'type': vmControlPauseCtrl.reason.type })
          .$promise
          .then(function (data) {
            NotificationService.successHandler(data, $rootScope.labels.reasonPauseUpdated);
            vmControlPauseCtrl.reason = null;
            vmControlPauseCtrl.hidenGrid = true;
            vmControlPauseCtrl.reasons.reload();
          })
          .catch(function (data) {
            vmControlPauseCtrl.hidenGrid = true;
            NotificationService.errorHandler(data, $rootScope.labels.errorUpdateReason);
          });
      }
    }

    function editReason (reason) {
      vmControlPauseCtrl.reason = reason;
      vmControlPauseCtrl.reason.type = reason.type;
      vmControlPauseCtrl.hidenGrid = false;
    }

    function cancelReason () {
      vmControlPauseCtrl.reason = null;
      vmControlPauseCtrl.reasons.reload();
      vmControlPauseCtrl.hidenGrid = true;
    }

    function canDeleteReason (reason) {
      vmControlPauseCtrl.modalDeleteReason = reason;
      FoundationApi.publish('pauseConfirmDeleteModal', 'open');
    }

    function deleteReason (id) {
      if (vmControlPauseCtrl.reasons.data.length <= 1) {
        NotificationService.warningHandler(null, $rootScope.labels.requiReasonPause);
        return;
      }
      ReasonService
        .delete({ 'id': id })
        .$promise
        .then(function (data) {
          vmControlPauseCtrl.modalDeleteReason = {};
          FoundationApi.publish('pauseConfirmDeleteModal', 'close');
          vmControlPauseCtrl.reasons.reload();
          NotificationService.successHandler(data, $rootScope.labels.sucRemoveReason);
        })
        .catch(function (data) {
          NotificationService.errorHandler(data, $rootScope.labels.reasonNotFound);
        });
    }

    function messageHandler (showMessage, message) {
      vmControlPauseCtrl.showMessage = showMessage;
      if (message != null) { vmControlPauseCtrl.message = message; }
    }
  }
})();
